import { makeAutoObservable } from "mobx";
import apiClient, { plainApiClient } from "../api";
import { uploadProfileHook } from "../api/hooks/Auth";
import AuthStore from "./AuthStore";
import UserStore from "./UserStore";
import SettingsStore from "./SettingsStore";
import PerformanceStore from "./PerformanceStore";
import { getBlobToBase64, getDecodedToken } from "../utils/functions";
import { getCookie } from "../utils/cookie";
import {
  deleteProfile,
  familyMembers,
  getBankDetails,
  getContact,
  getLiaison,
  getUnlockAcc,
} from "../api/hooks/profile";
class ProfileStore2 {
  status = "";
  usersContact = null;
  liaisonOfficer = null;
  bankDetails = null;
  allMembers = null;
  sidebarList = null;
  newProfilePic = null;
  clientImgUrl = null;
  liaison_img = null;
  allUsersContact = [];
  liaisonOfficersContact = [];
  amountProfile = [];
  lockedAccounts = undefined;
  lockedAccountImages = {};
  nonPrimaryUserData = [];
  localClients = [];
  singleUsersUrl = "";
  currentFamilyMembers = undefined;
  currentFamilyMembersImages = null;
  mapUsersData = [];
  constructor() {
    makeAutoObservable(this);
  }

  createAllUsersArray = (data) => {
    // creates array of provided length.. that is used to show saved data
    this.allUsersContact = Array(data);
    this.liaisonOfficersContact = Array(data);
    this.amountProfile = Array(data);
  };

  removeClientsPhoto(id) {
    delete this.currentFamilyMembersImages[id];
    UserStore.singleUsersUrl = "";
  }

  addNewProfilePic(file) {
    this.newProfilePic = file;
  }

  updateClientsImgUrl(url) {
    this.clientImgUrl = url;
  }

  uploadClientsProfile(file) {}

  uploadProfile2(file, userId, { onSucess, onFail }) {
    uploadProfileHook(file, `clients/${userId}/profilepics`)
      .then(({ data }) => {
        onSucess(data);
      })
      .catch((data) => {
        onFail(data);
      });
  }

  *getContactDetails(client_id, idx) {
    try {
      PerformanceStore.setLoaderStatus("contactDetailsStatus", "pending");
      // const response = yield apiClient.get(
      //   `clients/${client_id}/contactdetails`
      // );

      const response = yield getContact({ client_id });
      this.allUsersContact[idx] = response.data[0];
      this.usersContact = response.data[0];
      if (response.status === 200) {
        PerformanceStore.setLoaderStatus("contactDetailsStatus", "success");
        PerformanceStore.loaderCloseFunction();
      }
    } catch (error) {
      this.status = "error";
      AuthStore.updateLoadingFullScreen(false);
    }
  }

  *getLiaisonsDetails(client_id, la_officers_id, idx) {
    try {
      PerformanceStore.setLoaderStatus("liasionDetailsStatus", "pending");
      // const response = yield apiClient.get(
      //   `clients/${client_id}/laisonofficers/${la_officers_id}/profiledetails`
      // );
      const response = yield getLiaison({ client_id, la_officers_id });
      this.liaisonOfficer = response.data;
      this.liaisonOfficersContact[idx] = response.data;

      if (response.data.profile_pic) {
        PerformanceStore.setLoaderStatusForImage("getImage3", "pending");
        this.getImageFromAPIProfile({
          path: response.data.profile_pic,
          onSuccess: (imageBlob) => {
            getBlobToBase64(imageBlob).then((url) => {
              let resImage = url;
              this.liaison_img = resImage;
              PerformanceStore.setLoaderStatusForImage("getImage3", "success");
            });
          },
          onFail: (error) => {},
        });
      }

      if (response.status === 200) {
        PerformanceStore.setLoaderStatus("liasionDetailsStatus", "success");
        PerformanceStore.loaderCloseFunction();
      }
    } catch (error) {
      this.status = "error";
      AuthStore.updateLoadingFullScreen(false);
    }
  }

  unlockAccount(client, { onSuccess, onFail }) {
    window.scrollTo(0, 0);
    AuthStore.updateLoadingFullScreen(true);
    apiClient
      .put(`clients/${client.user_id}/unlock`)
      .then((response) => {
        onSuccess(response);
        this.getLockedAccounts();
        AuthStore.updateLoadingFullScreen(false);
      })
      .catch((error) => {
        onFail();
        AuthStore.updateLoadingFullScreen(false);
      });
  }

  getLockedAccounts() {
    window.scrollTo(0, 0);
    AuthStore.updateLoadingFullScreen(true);
    //apiClient
    // .get("lockeduseraccounts")
    getUnlockAcc()
      .then((data) => {
        this.lockedAccounts = data.data;

        data.data.forEach(({ client }) => {
          if (client.profile_pic) {
            SettingsStore.getImageFromAPI({
              path: client.profile_pic,
              onSuccess: (imageBlob) => {
                getBlobToBase64(imageBlob).then((url) => {
                  let resImage = url;
                  this.lockedAccountImages = {
                    ...this.lockedAccountImages,
                    [client.user_id]: resImage,
                  };
                });
              },
            });
          }
        });
        AuthStore.updateLoadingFullScreen(false);
      })
      .catch(() => {
        AuthStore.updateLoadingFullScreen(false);
      });
  }

  *getBankDetails(client_id, idx) {
    try {
      PerformanceStore.setLoaderStatus("getBankStatus", "pending");
      //const response = yield apiClient.get(`clients/${client_id}/profile`);
      const response = yield getBankDetails({ client_id });
      this.bankDetails = response.data;
      this.amountProfile[idx] = response.data;
      if (response.status === 200) {
        PerformanceStore.setLoaderStatus("getBankStatus", "success");
        PerformanceStore.loaderCloseFunction();
      }
      return response;
    } catch (error) {
      this.status = "error";
      AuthStore.updateLoadingFullScreen(false);
    }
  }
  *getImageFromAPI({ path, onSuccess, onFail }) {
    const response = yield apiClient.get(path, { responseType: "blob" });
    return response;
  }
  *deleteProfile(picture_id) {
    try {
      window.scrollTo(0, 0);
      AuthStore.updateLoadingFullScreen(true);
      const response = yield apiClient.delete(`userProfilePics/${picture_id}`);
      this.getFamilyClients("offloader");
      if (response.status === 200) {
        AuthStore.updateLoadingFullScreen(false);
      }
    } catch (error) {
      this.status = "error";
      AuthStore.updateLoadingFullScreen(false);
    }
  }

  deleteProfile2({ pic_id, onSuccess, onFail }) {
    // apiClient
    //   .delete(`userProfilePics/${pic_id}`)
    deleteProfile({ pic_id })
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail(error);
      });
  }
  mapUsers(data, isFam) {
    if (!isFam || data.length === 1) {
      this.mapUsersData = data;
    } else {
      const nonPrimaryMembers = data?.filter((eachData) => !eachData.isprimary);
      const primaryMember = data?.filter((eachData) => eachData.isprimary);
      nonPrimaryMembers.unshift(primaryMember[0]);
      this.mapUsersData = nonPrimaryMembers;
    }
  }

  getImagesForDisp(arrayData) {}

  getUsersImage({ path, onSuccess, onFail }) {
    plainApiClient
      .get(path, { responseType: "blob" })
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail(error);
      });
  }

  getImage(path, userType) {
    if (!path && userType === "normal") {
      UserStore.singleUsersUrl = "";
    }
    path &&
      userType === "normal" &&
      PerformanceStore.setLoaderStatusForImage(
        `${UserStore?.userData?.user_id}3`,
        "pending"
      );
    path &&
      this.getUsersImage({
        path,
        onSuccess: (imageBlob) => {
          getBlobToBase64(imageBlob).then((url) => {
            let resImage = url;
            if (userType === "normal") {
              UserStore.singleUsersUrl = resImage;
              PerformanceStore.setLoaderStatusForImage(
                `${UserStore?.userData?.user_id}3`,
                "success"
              );
            } else {
              UserStore.liaisonImage = resImage;
            }
          });
        },
        onFail: (error) => {
          if (userType === "normal") UserStore.singleUsersUrl = "";
          else UserStore.liaisonImage = "";
          PerformanceStore.setLoaderStatusForImage(
            `${UserStore?.userData?.user_id}3`,
            "failed"
          );
          PerformanceStore.loaderCloseFunction();
        },
      });
  }

  getProfileImage(path) {
    this.getImage(path ? path : "");
  }

  getProfileFamilyMembers() {
    UserStore.getFamilyClients(
      "none",
      (data) => {
        this.localClients = data;
        this.getImagesForDisp(this.localClients);
      },
      () => {}
    );
  }

  getImageFromAPIProfile({ path, onSuccess, onFail, from }) {
    plainApiClient
      .get(path, { responseType: "blob" })
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail(error);
      });
  }

  setSingleUsersUrl(url) {
    UserStore.singleUsersUrl = url;
  }

  getFamilyClients(isOtherApi, onSuccess, onFail) {
    const familyId = UserStore.userData.family_id || getCookie("famid");

    PerformanceStore.setLoaderStatus("getFamilyClientsStatus", "pending");
    // apiClient
    //   .get(`families/${familyId}/members`)
    familyMembers({ familyId })
      .then(({ data }) => {
        if (onSuccess) {
          onSuccess(data);
        }
        this.currentFamilyMembers = data;
        UserStore.setCurrentFamMembersOrImages("currentFamilyMembers", data);
        const forLiaison = data?.filter(
          (eachData) =>
            String(eachData.user_id) === getCookie("selectedUsersId")
        );

        // user whos image is updated
        const primaryMember = data?.filter(
          (eachData) =>
            String(eachData.user_id) === getCookie("selectedUsersId")
        );

        // to update the image in userStore (for header and profile dropdown)
        if (isOtherApi === "offloader") {
          UserStore.singleUsersUrl = "";
          UserStore.userData = {
            ...UserStore.userData,
            profile_pic:
              UserStore.getData === "fam"
                ? primaryMember?.[0]?.profile_pic
                : UserStore.userData.profile_pic,
          };
        }
        // to get the images to display on header and profile dropdown (or wherever required)
        if (primaryMember?.[0]?.profile_pic) {
          this.getImage(
            primaryMember?.[0]?.profile_pic
              ? primaryMember?.[0]?.profile_pic
              : "",
            "normal"
          );
        }

        if (isOtherApi === "nonPrimaryProfile") {
          this.callForNonPrimary(
            UserStore.userData.user_id || getCookie("selectedUsersId"),
            forLiaison[0]?.liasonOfficers?.[0]?.liasonOfficerId,
            forLiaison
          );
        }

        const imageArr = {};

        data?.forEach((eachClient, index) => {
          if (eachClient.profile_pic) {
            PerformanceStore.setLoaderStatusForImage(
              `${eachClient.user_id}3`,
              "pending"
            );
            this.getImageFromAPIProfile({
              path: eachClient.profile_pic,
              onSuccess: (imageBlob) => {
                getBlobToBase64(imageBlob).then((url) => {
                  let resImage = url;
                  imageArr[eachClient.user_id] = resImage;
                  this.currentFamilyMembersImages = {
                    ...this.currentFamilyMembersImages,
                    ...imageArr,
                  };
                  UserStore.currentFamilyMembersImages = {
                    ...this.currentFamilyMembersImages,
                    ...imageArr,
                  };
                  PerformanceStore.setLoaderStatusForImage(
                    `${eachClient.user_id}3`,
                    "success"
                  );
                  PerformanceStore.loaderCloseFunction();
                });
              },
              onFail: (error) => {
                imageArr[eachClient.user_id] = "";
                this.currentFamilyMembersImages = {
                  ...this.currentFamilyMembersImages,
                  ...imageArr,
                };
                UserStore.currentFamilyMembersImages = {
                  ...this.currentFamilyMembersImages,
                  ...imageArr,
                };
                PerformanceStore.setLoaderStatusForImage(
                  `${eachClient.user_id}3`,
                  "failed"
                );
                PerformanceStore.loaderCloseFunction();
              },
            });
          }

          index === data.length - 1 && UserStore.setCurrenMembersImages();
        });

        if (isOtherApi === "profile") {
          this.callApi(data.length);
        } else if (
          isOtherApi === "offloader" &&
          getDecodedToken()?.user_type !== "customer" &&
          UserStore.isSelectedUserPrimary
        ) {
          this.mapUsers(this.currentFamilyMembers, true);
        }
        PerformanceStore.setLoaderStatus("getFamilyClientsStatus", "success");
        PerformanceStore.loaderCloseFunction();
      })
      .catch((err) => {
        AuthStore.updateLoadingFullScreen(false);
        if (onFail) {
          onFail();
        }
      });
  }

  callApi(length) {
    // this mapped data is user list to show it at the side bar
    this.mapUsers(this.currentFamilyMembers, true);
    const user_id = this.mapUsersData[0]?.user_id;
    const liason_id =
      this.mapUsersData[0]?.liasonOfficers?.[0]?.liasonOfficerId;
    // user profile saved data
    this.createAllUsersArray(length);
    // 3 apis for showing user details..
    this.getBankDetails(user_id, 0);
    this.getContactDetails(user_id, 0);
    liason_id !== undefined && this.getLiaisonsDetails(user_id, liason_id, 0);
  }

  secondTimeCall(user_id, idx, liason_id) {
    if (this.allUsersContact[idx] === undefined) {
      window.scrollTo(0, 0);
      PerformanceStore.setCurrentLoader("fullScreen");
      AuthStore.updateLoadingFullScreen(true);
      this.getContactDetails(user_id, idx);
    }
    if (this.amountProfile[idx] === undefined) {
      window.scrollTo(0, 0);
      PerformanceStore.setCurrentLoader("fullScreen");
      AuthStore.updateLoadingFullScreen(true);
      this.getBankDetails(user_id, idx);
    }
    if (
      this.liaisonOfficersContact[idx] === undefined &&
      liason_id !== undefined
    ) {
      window.scrollTo(0, 0);
      PerformanceStore.setCurrentLoader("fullScreen");
      AuthStore.updateLoadingFullScreen(true);
      this.getLiaisonsDetails(user_id, liason_id, idx);
    }
  }

  callForNonPrimary(user_id, liason_id, nonPrimaryUserData) {
    this.mapUsers(nonPrimaryUserData, false);
    this.createAllUsersArray(1);
    this.getBankDetails(user_id, 0);
    this.getContactDetails(user_id, 0);
    if (liason_id !== undefined) {
      this.getLiaisonsDetails(user_id, liason_id, 0);
    }
  }

  setProfileStore2ToIntialState() {
    this.status = "";
    this.usersContact = null;
    this.liaisonOfficer = null;
    this.bankDetails = null;
    this.allMembers = null;
    this.sidebarList = null;
    this.newProfilePic = null;
    this.clientImgUrl = null;
    this.liaison_img = null;
    this.allUsersContact = [];
    this.liaisonOfficersContact = [];
    this.amountProfile = [];
    this.lockedAccounts = undefined;
    this.lockedAccountImages = {};
    this.nonPrimaryUserData = [];
    this.localClients = [];
    this.singleUsersUrl = "";
    this.currentFamilyMembers = undefined;
    this.currentFamilyMembersImages = null;
    this.mapUsersData = [];
  }
}

const Profile = new ProfileStore2();

export default Profile;
